import { LoginResponse, logoutUser, queryKeyFn } from '@sit/client-shared';
import { put } from 'redux-saga/effects';
import { track } from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import api from '../../helpers/api';
import toastr from '../../helpers/toastr';
import { queryClient } from '../../hooks/api/query/client';
import { selectToken } from '../selectors';
import { store } from '../store';
import * as actions from './actions';

export function* getUserRequestSaga(payload: any): any {
  try {
    const res = yield api.send({
      url: '/users',
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getUserRequestSuccess(res));
  } catch (error) {
    yield put(actions.getUserRequestFailure(error));
  }
}

export function* loginRequestSaga(payload: any) {
  try {
    const res: LoginResponse = yield api.send({
      url: '/auth/login',
      method: 'POST',
      data: payload.data,
      dontCheckForUnauthorized: true,
      skipToast: true,
    });
    yield put(actions.loginRequestSuccess(res));
    track(trackEvents.LOGIN_SUCCESS);
  } catch (error: any) {
    yield put(actions.loginRequestFailure(error));
    if (error?.message?.indexOf('Two-Factor authentication is required') > -1) {
      payload.data.cb?.();
    } else {
      track(trackEvents.LOGIN_ERROR);
    }
  }
}

export function* logoutRequestSaga(payload: any): any {
  try {
    yield logoutUser(payload.data?.token, payload.data?.refreshToken);
    if (payload.data?.navigate) {
      yield payload.data.navigate('/login');
    }
    track(trackEvents.LOGOUT);
    sessionStorage?.clear();
    queryClient.clear();
  } catch (error) {
    // do nothing
  }
}

export function* registerResendEmailRequestSaga(payload: any): any {
  try {
    const res = yield api.send({
      url: '/pub/signup/resend-email',
      method: 'POST',
      data: payload.data,
    });
    yield put(actions.registerResendEmailRequestSuccess(res));
  } catch (error) {
    yield put(actions.registerResendEmailRequestFailure(error));
  }
}

export function* registerEmployeeRequestSaga(payload: any): any {
  try {
    const res = yield api.send({
      url: '/pub/employee/signup',
      method: 'POST',
      data: payload.data,
    });
    yield put(actions.registerEmployeeRequestSuccess(res));
  } catch (error) {
    yield put(actions.registerEmployeeRequestFailure(error));
  }
}

export function* sendFallbackMfaCodeRequestSaga(payload: any): any {
  try {
    yield api.send({
      url: '/auth/mfa-fallback',
      method: 'POST',
      data: payload.data,
    });
    yield put(actions.sendFallbackMfaCodeRequestSuccess());
  } catch (error) {
    yield put(actions.sendFallbackMfaCodeRequestFailure(error));
  }
}

export function* updatePasswordRequestSaga(payload: any): any {
  try {
    const res = yield api.send({
      url: '/users/change-password',
      method: 'POST',
      data: payload.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updatePasswordRequestSuccess(res));
    toastr.success('Changes saved!');
  } catch (error) {
    yield put(actions.updatePasswordRequestFailure(error));
  }
}

export function* updateUserRequestSaga(payload: any): any {
  try {
    const res = yield api.send({
      url: `/users/${payload.data.id}`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    if (payload.data.id === store.getState().user.data.id) {
      yield put(actions.updateUserRequestSuccess(res));
    }
    yield queryClient.invalidateQueries(
      queryKeyFn({
        path: '/team',
        operationId: 'getApiTeam',
        variables: {},
      }),
    );
  } catch (error) {
    yield put(actions.updateUserRequestFailure(error));
  }
}

export function* updateAccessToken(payload: any) {
  yield put(actions.getUserRequest());
  yield queryClient.invalidateQueries(
    queryKeyFn({
      path: '/companies',
      operationId: 'getApiCompany',
      variables: {},
    }),
  );
}
